import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RequestService {

  public url = environment.apiUrl;

  constructor(public http: HttpClient, public translate: TranslateService) { }

  get(path: string) {
      let promise = new Promise<any>((resolve, reject) => {
          let url = this.url + path;

          let headers: any = { headers: {} };
          if (localStorage.getItem('hotel_token')) {
              headers.headers['auth-token'] = localStorage.getItem('hotel_token');
          }

          this.http.get(url, headers)
              .toPromise()
              .then(res => {
                  resolve(res);
              }).catch(async err => {
                  //await(await this.alertCtrl.create({header:this.translate.instant('ERROR'), message:this.translate.instant(err.error)})).present();
                  reject(err);
              });
      })
      return promise;
  }

  post(path: string, data: any) {
      let promise = new Promise<any>((resolve, reject) => {
          let url = this.url + path;

          let headers: any = { headers: {} };
          if (localStorage.getItem('hotel_token')) {
              headers.headers['auth-token'] = localStorage.getItem('hotel_token');
          }

          this.http.post(url, data, headers)
              .toPromise()
              .then(res => {
                  resolve(res);
              }).catch(async err => {
                  //await(await this.alertCtrl.create({header:this.translate.instant('ERROR'), message:this.translate.instant(err.error)})).present();
                  reject(err);
              });
      })
      return promise;
  }

  patch(path: string, data: any) {
      let promise = new Promise<any>((resolve, reject) => {
          let url = this.url + path;

          let headers: any = { headers: {} };
          if (localStorage.getItem('hotel_token')) {
              headers.headers['auth-token'] = localStorage.getItem('hotel_token');
          }

          this.http.patch(url, data, headers)
              .toPromise()
              .then(res => {
                  resolve(res);
              }).catch(async err => {
                  //await(await this.alertCtrl.create({header:this.translate.instant('ERROR'), message:this.translate.instant(err.error)})).present();
                  reject(err);
              });
      })
      return promise;
  }

  put(path: string, data: any) {
      let promise = new Promise<any>((resolve, reject) => {
          let url = this.url + path;

          let headers: any = { headers: {} };
          if (localStorage.getItem('hotel_token')) {
              headers.headers['auth-token'] = localStorage.getItem('hotel_token');
          }

          this.http.put(url, data, headers)
              .toPromise()
              .then(res => {
                  resolve(res);
              }).catch(async err => {
                  //await(await this.alertCtrl.create({header:this.translate.instant('ERROR'), message:this.translate.instant(err.error)})).present();
                  reject(err);
              });
      })
      return promise;
  }

  delete(path: string) {
      let promise = new Promise<any>((resolve, reject) => {
          let url = this.url + path;

          let headers: any = { headers: {} };
          if (localStorage.getItem('hotel_token')) {
              headers.headers['auth-token'] = localStorage.getItem('hotel_token');
          }

          this.http.delete(url, headers)
              .toPromise()
              .then(res => {
                  resolve(res);
              }).catch(async err => {
                  //await(await this.alertCtrl.create({header:this.translate.instant('ERROR'), message:this.translate.instant(err.error)})).present();
                  reject(err);
              });
      })
      return promise;
  }
}